import {
  type FlowAutomatedVoiceBlockConfig,
  FlowAutomatedVoiceBlockConfigSchema,
  FlowDurationUnits,
} from 'flow-schema';
import { getAutomatedVoice } from 'primary-schema';
import { z } from 'zod';

import { AutomatedVoiceFormFields } from './FormFields';
import { automatedVoiceDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';
import { defaultCommunicationWindow } from '../shared/CommunicationWindow';

const AutomatedVoiceBlockConfigFormSchema = FlowAutomatedVoiceBlockConfigSchema.safeExtend({
  callerPhoneNumberId: z.uuid('Please select a caller phone number.'),
});

export const automatedVoiceNodeConfig: BlockConfigProps<FlowAutomatedVoiceBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'AutomatedVoice',
  defaultConfig: {
    calleePhoneNumber: '',
    callerPhoneNumberId: '',
    message: 'Hello, this is an automated message from your healthcare provider.',
    language: 'en',
    voice: getAutomatedVoice({ language: 'en' }).id,
    voiceSpeed: 1,
    timeout: {
      value: 15,
      units: FlowDurationUnits.Minutes,
    },
    communicationWindow: defaultCommunicationWindow,
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.calleePhoneNumber, config.message],
      };
    },
    schema: AutomatedVoiceBlockConfigFormSchema,
    FormFields: AutomatedVoiceFormFields,
  },
  documentationMarkdown: automatedVoiceDocumentationMarkdown,
};
